import React from "react";
import AccountingManualTransactionsGenericSkeleton from "./AccountingManualTransactionsGenericSkeleton";

const AccountingManualTransactionsDetailSkeleton = () => {
  return (
    <>
      <AccountingManualTransactionsGenericSkeleton />
    </>
  );
};

export default AccountingManualTransactionsDetailSkeleton;
